// extracted by mini-css-extract-plugin
export default {"modal__btnGroup":"styles_modal__btnGroup__qIub0","modal__btnClose":"styles_modal__btnClose__6aSzi","popularLinks":"styles_popularLinks__BOdTP","link":"styles_link__UxjUS"};